import { __read, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { createContext } from '../../utils/createContext.js';
import 'react';
import 'react-helmet';
import '@emotion/react';
import { contextError } from '../../UIProvider/linkComponentContext.js';
import '@compono/ui-theme-compono';
import '../../hooks/useDetectInputMethod.js';
import '../../Toaster/Toaster.js';

var _a = __read(createContext({
    name: "MainNav",
}), 2), useMainNavContext = _a[0], MainNavContext = _a[1];
var MainNavConsumer = MainNavContext.Consumer;
var useNavLinkComponent = function (ref) {
    var navLinkComponent = useMainNavContext().navLinkComponent;
    if (navLinkComponent) {
        contextError(ref, navLinkComponent);
        if ("__forwardRef__" in navLinkComponent) {
            return navLinkComponent.__forwardRef__;
        }
    }
    return navLinkComponent;
};
var MainNavProvider = function (_a) {
    var children = _a.children, _b = _a.themeKey, themeKey = _b === void 0 ? "globalNav" : _b, navLinkComponent = _a.navLinkComponent;
    var contextValue = {
        themeKey: themeKey,
        navLinkComponent: navLinkComponent,
    };
    return (jsx(MainNavContext.Provider, __assign({ value: contextValue }, { children: children })));
};

export { MainNavConsumer, MainNavProvider, useMainNavContext, useNavLinkComponent };
//# sourceMappingURL=index.js.map
